module.exports = __webpack_public_path__ + "img/ayosjuan-logo.240b8101.png";